import React from 'react';
import clsx from 'clsx';
import styles from './CardDescription.module.scss';

type CardDescriptionProps = React.ComponentProps<'p'>;

export const CardDescription: React.FC<CardDescriptionProps> = ({ children, className, ...props }) => {
    return (
        <p
            className={clsx(styles.description, className)}
            {...props}
        >
            {children}
        </p>
    );
};
